import { Box, Tabs, Tab, TextField, Typography, InputAdornment } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CandidateReferralPayment from '../ReferralPayments/CandidateReferralPayment';
import JobReferralPayment from '../ReferralPayments/JobReferralPayment';
import TabList from '@mui/lab/TabList';
import TabContext from '@mui/lab/TabContext';
import ClientReferralPayments from './ClientReferralPayments';
import ReferralCommison from './ReferralCommission';
import { useSelector } from 'react-redux';
import ReferralPaymentNew from './ReferralPaymentNew';

const ReferralPayment = () => {

    const { Profile } = useSelector?.((state) => state?.common)
    const userRole = Profile?.profile?.role


    const [newTab, setNewTab] = useState(() => userRole === "recruiter" ? Number(localStorage.getItem("referralPaymentTab")) || 0 : 3);

    const handleTabChange = (event, newValue) => {
        setNewTab(newValue);
        localStorage.setItem("referralPaymentTab", newValue);
    };

    const renderTabContent = () => {
        switch (newTab) {
            case 0:
                // return <CandidateReferralPayment />;
                return <ReferralPaymentNew />;
            case 1:
                // return <JobReferralPayment />;
                return <ReferralPaymentNew />;
            case 2:
                // return <ClientReferralPayments />;
                return <ReferralPaymentNew />;
            default:
                if (userRole !== "recruiter") {
                    return <ReferralCommison />;
                }
                return null;
        }
    };

    return (
        <Box className="container">
            {/* Header Section */}
            {
                // userRole !== "recruiter" &&
                // <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
                //     <Box>
                //         <Typography className="title">Referral Commissions</Typography>
                //     </Box>
                // </Box>
                
            }

            {/* {
                userRole === "recruiter" ?
                    <TabContext value={newTab}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '20px' }}>
                            <TabList onChange={handleTabChange} textColor="primary"
                                indicatorColor="secondary">
                                <Tab
                                    label="Commission Info"
                                    className="tabs"
                                    value={0}
                                    sx={{ textTransform: 'none', color: newTab === 0 ? '#7F56D9' : '#475467', fontWeight: 600 }}
                                />
                                <Tab
                                    label="Job Referrals"
                                    className="tabs"
                                    value={1}
                                    sx={{ textTransform: 'none', color: newTab === 1 ? '#7F56D9' : '#475467', fontWeight: 600 }}
                                />
                                <Tab
                                    label="Client Referrals"
                                    className="tabs"
                                    value={2}
                                    sx={{ textTransform: 'none', color: newTab === 2 ? '#7F56D9' : '#475467', fontWeight: 600 }}
                                />
                            </TabList>
                        </Box>
                    </TabContext> : <></>
            } */}

            <Box sx={{ marginTop: '20px' }}>
                {renderTabContent()}
            </Box>
        </Box>
    );
};

export default ReferralPayment;
